<template>
    <div id="menu">
        <el-menu class="menu" @select="selectMenu" ref="menu" active-text-color="#000000">
            <template v-for="item in menuList">
                <el-menu-item v-if="!item.children" :index="item.path">
                    <span slot="title">{{ item.meta.title }}</span>
                </el-menu-item>

                <el-submenu v-if="item.children" :index="item.path">
                    <template slot="title">
                        <span>{{ item.meta.title }}</span>
                    </template>
                    <menuList :menuList="item.children"></menuList>
                </el-submenu>
            </template>
        </el-menu>
    </div>
</template>

<script>

import menuList from '@/components/menu.vue' 

export default {
    name: 'menuList',
    props: ['menuList'],
    components: {
        menuList
    },
    data() {
        return {

        }
    },
    methods: {
        selectMenu(e) {
            // console.log(e)
            let fuName = this.menuList.find(item => item.path == e)
            this.$router.push({
                path: e
            })
            this.$refs.menu.close('product')
            if (fuName.meta.fuName) {
                this.$bus.$emit('closeMenu', fuName.meta.fuName)
            } else {
                this.$bus.$emit('closeMenu', fuName.name)
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.menu {
    background-color: rgba(255, 255, 255, 0.8);
}
</style>